import React, { useState } from 'react';
import { Modal, Form, Input } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import { TeamOutlined } from '@ant-design/icons';
import teamService from '../../services/teamService';
import { useInit } from '../../contexts/InitContext';

/**
 * 创建团队 Modal 组件
 * @param {Object} props - 组件属性
 * @param {boolean} props.visible - 是否显示 Modal
 * @param {Function} props.onCancel - 取消回调
 * @param {Function} props.onSuccess - 成功回调
 * @returns {ReactElement} 创建团队 Modal 组件
 */
const CreateTeamModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { forceReinit } = useInit();

  // 处理确认创建
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      // 构建创建团队的请求数据
      const teamData = {
        name: values.name,
        display_name: values.name, // 使用团队名称作为显示名称
        description: values.description,
        category: 'team',
        settings: {
          visibility: 'public',
          join_approval_required: true,
          allow_member_posts: true,
          member_limit: 50
        }
      };

      // 调用创建团队 API
      const result = await teamService.createTeam(teamData);

      console.log('创建团队 API 返回结果:', result);
             // 检查多种可能的成功响应格式
       if (result) {
         message.success('团队创建成功');
         form.resetFields();
         console.log('新创建的团队数据:', result);
         
         // 强制重新初始化数据，获取最新的团队信息
         try {
           await forceReinit();
           console.log('创建团队后重新初始化成功');
         } catch (error) {
           console.warn('重新初始化失败，但不影响团队创建:', error);
         }
         
         // 传递新创建的团队数据给父组件
         onSuccess?.(result);
         onCancel();
       } else {
         throw new Error(result?.message || result?.error || '创建失败');
       }
    } catch (error) {
      console.error('创建团队失败:', error);
      window.message?.error(error.message || '创建团队失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 处理取消
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  console.log('CreateTeamModal 渲染，visible:', visible);
  
  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      title={
        <div className="flex items-center gap-2">
          <TeamOutlined className="text-blue-500" />
          <span className="text-lg font-medium">创建团队</span>
        </div>
      }
      okText="创建"
      cancelText="取消"
      confirmLoading={loading}
      width={500}
      centered
      destroyOnClose={false}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" className="py-4">
        <Form.Item
          label="团队名称"
          name="name"
          rules={[
            { required: true, message: '请输入团队名称' },
            { max: 50, message: '团队名称不能超过50个字符' }
          ]}
        >
          <Input
            placeholder="请输入团队名称"
            maxLength={50}
            showCount
          />
        </Form.Item>

        <Form.Item
          label="团队描述"
          name="description"
          rules={[
            { required: true, message: '请输入团队描述' },
            { max: 200, message: '团队描述不能超过200个字符' }
          ]}
        >
          <Input.TextArea
            placeholder="请输入团队描述，介绍团队的目标和特色..."
            rows={4}
            maxLength={200}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateTeamModal;
